import * as camsAndForecastsPath from './camsAndForecastsPath';

export const mapPath = camsAndForecastsPath.mapPath;
export const geonameMapPath = camsAndForecastsPath.geonameMapPath;
export spotForecastPath, { spotReportPath } from './spotForecastPath';
export subregionForecastPath, { premiumAnalysisLinkMap } from './subregionForecastPath';



// WEBPACK FOOTER //
// ./src/utils/urls/index.js